import React from 'react'
import {
  trackBikeProfileSelectedDates,
  trackBikeBookingSuccess,
  trackBikeProfilePricing,
} from '../../elements/tracking/bikeProfileTracking.js'
import MotorcycleBookingWCalendarPanel from './paymentModule'
//Since we use this twice on the BikeListing Page, we use this wrapper to
//clean up that file some. This is not a very reusable component, but that's ok!

const MotorcycleBookingPanelWrapper = (props) => {
  const {
    bikeData,
    bikeID,
    startDate,
    endDate,
    onClearDates,
    onDatesChange,
    paneView,
    toggleFixedClass,
    onPricingSuccess,
    onChange,
  } = props

  return (
    <MotorcycleBookingWCalendarPanel
      toggleFixedClass={toggleFixedClass}
      timezone={bikeData.bike_timezone}
      blackOutDates={bikeData.bike_blackout_dates}
      bikeID={bikeID}
      startDate={startDate}
      endDate={endDate}
      onClearDates={onClearDates}
      onDateChange={(startDate, endDate) => {
        onDatesChange(startDate, endDate)
        trackBikeProfileSelectedDates()
      }}
      sameDayAvailable={bikeData.same_day_available}
      bikeData={bikeData}
      multidayDiscountApplied={bikeData.multiday_discount_applied}
      baseRentalPriceCents={bikeData.base_bike_daily_price_cents}
      baseRentalPriceCurrency={bikeData.base_bike_daily_price_currency}
      desktopOrMobile={paneView}
      processingDescription={
        'Booking Processing from Bike Profile Page - ' + bikeID
      }
      pricingDescription={'Pricing Call from Bike Profile Page - ' + bikeID}
      onPricingSuccess={(pricingParams, pricingInfo) => {
        trackBikeProfilePricing(
          pricingParams,
          { pricing: pricingInfo },
          bikeData
        )
        onPricingSuccess(pricingInfo)
      }}
      onBookingSuccess={(bookingData, priceSummary, response, resID) =>
        trackBikeBookingSuccess(
          bookingData,
          priceSummary,
          response,
          bikeData,
          () => this.props.history.push('/payments/book/' + resID),
          resID
        )
      }
      closedDays={bikeData.closed_days}
    />
  )
}

export default MotorcycleBookingPanelWrapper
